import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CardPosts from "../CardPosts/index";
import ListItem from "@material-ui/core/ListItem";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  itemText: {
    fontSize: 14,
    color: "#484848",
    margin: "7px 0"
  },
  listItemStyled: {
    borderBottom: "1px solid #e7e7e7",
    "&:$last-child": {
      borderBottom: "none"
    }
  }
}));

function ListItemLink(props) {
  const classes = useStyles();
  return (
    <ListItem
      button
      component="a"
      {...props}
      divider={false}
      classes={{ root: classes.listItemStyled }}
    />
  );
}

function CategoriesList(props) {
  const classes = useStyles();
  let categories = [
    "Todas",
    "Derecho Laboral",
    "Familia",
    "Vivienda",
    "Derechos Laborales",
    "Bienes inmuebles",
    "Trámites legales",
    "Propiedad intelectual",
    "Seguridad vial",
    "Derecho penal"
  ];

  return (
    <div className={classes.root}>
      <CardPosts title="Categorías" height="categories">
        {categories.map(category => {
          return (
            <ListItemLink href={`/articulos/${category}`} disableGutters key={category}>
              <p className={classes.itemText}>{category}</p>
            </ListItemLink>
          );
        })}
      </CardPosts>
    </div>
  );
}

export default CategoriesList;
